<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-11 14:35:07
 * @LastEditTime: 2023-02-08 09:27:26
 * @Description:
 * @FilePath: \com.tudouec.manager.pm.vue.v1d:\codeLibraty\金豆\中国薯网官网\web\website\src\components\NavMenu.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="menu-bg">
    <div>
      <img width="220px" src="http://wwwadm.tudouec.com/profile/resource/www_img/logo.png" alt="" />
    </div>
    <div>
      <el-menu
        :default-active="$route.path"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        text-color="#333333"
        active-text-color="#019845"
        router
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/aboutus">关于我们</el-menu-item>
        <el-menu-item index="/quotation">薯价行情</el-menu-item>
        <el-menu-item index="/smartService">智慧服务</el-menu-item>
        <el-menu-item index="/news">政策资讯</el-menu-item>
        <el-menu-item index="/cooperator">合作共赢</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  name: "NavMenu",
  data() {
    return {};
  },
  mounted(){

  },
  methods: {
    handleSelect() {},
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.menu-bg {
  @include body-padding();
  height: 88px;
  background: #ffffff;
  opacity: 0.8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-menu--horizontal > .el-menu-item {
    width: 100px;
    text-align: center;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenu.vue